import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'

export default {
  name: 'MbankTermsOfUseModal',
  extends: BaseModal,
}
